import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslate } from '@repo/unicity'
import ChangeShippingMethodRadio from './ChangeShippingMethodRadio'
import { changeLinkButtonSx, ModalContent } from '../payments.styles'
import { useShippingMethodChange } from '../hooks/useShippingMethodChange'
import { useNavigateToShipping } from '../hooks/useNavigateToShipping'

const ShippingMethodSection = () => {
    const { translate } = useTranslate()
    const goToShipping = useNavigateToShipping()
    const { modalOpen, draftMethod, setDraftMethod, label, handleOpenModal, handleConfirm, handleCloseBackdrop, formatData } = useShippingMethodChange()

    return (
        <>
            <Box data-testid="shipping-method-section-box">
                <Stack direction="row" justifyContent="space-between" alignItems="center" data-testid="shipping-method-section-header">
                    <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#003764' }} data-testid="shipping-method-section-title">
                        {translate('shipping_method')}
                    </Typography>
                    <Button
                        size="small"
                        variant="text"
                        onClick={handleOpenModal}
                        disableRipple
                        sx={changeLinkButtonSx}
                        data-testid="shipping-method-section-change-btn">
                        {translate('change')}
                    </Button>
                </Stack>
                <Typography variant="body2" sx={{ fontSize: 14, fontWeight: 400, color: '#003764', mt: 0.5 }} data-testid="shipping-method-section-label">
                    {label}
                </Typography>
            </Box>

            <Modal open={modalOpen} onClose={handleCloseBackdrop} data-testid="shipping-method-section-modal">
                <ModalContent data-testid="shipping-method-section-modal-content">
                    <Typography sx={{ fontSize: 24, fontWeight: 700, mb: 2, color: '#003764' }} data-testid="shipping-method-section-modal-title">
                        {translate('change_shipping_method')}
                    </Typography>
                    <ChangeShippingMethodRadio
                        freight={formatData?.freight}
                        selectedMethod={draftMethod}
                        onMethodChange={setDraftMethod}
                        data-testid="shipping-method-section-radio"
                    />
                    <Box
                        sx={{
                            mt: 3,
                            display: 'flex',
                            flexDirection: { xs: 'column-reverse', sm: 'row' },
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 2
                        }}
                        data-testid="shipping-method-section-modal-actions">
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: 400,
                                color: '#003B6F',
                                textDecoration: 'underline',
                                textUnderlineOffset: '3px',
                                cursor: 'pointer'
                            }}
                            onClick={() => goToShipping()}
                            data-testid="shipping-method-section-back-link">
                            {translate('back_to_shipping_address')}
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={handleConfirm}
                            sx={{
                                width: 223,
                                height: 48,
                                borderRadius: '99px',
                                fontFamily: "'Poppins', 'Noto Sans Thai', sans-serif",
                                fontWeight: 600,
                                fontSize: 20,
                                letterSpacing: '-0.2px',
                                textTransform: 'none',
                                boxShadow: 'none',
                                bgcolor: '#5a8fc4',
                                '&:hover': { boxShadow: 'none', bgcolor: '#4a7fb4' },
                                '&.Mui-disabled': { bgcolor: '#ccdeef', color: 'white' }
                            }}
                            data-testid="shipping-method-section-confirm-btn">
                            {translate('confirm')}
                        </Button>
                    </Box>
                </ModalContent>
            </Modal>
        </>
    )
}

export default ShippingMethodSection
